module.exports = __webpack_public_path__ + "static/tags-19fda971a17618b202b0f0cfea49b0fb.png";